var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScaleMobile = function SvgScaleMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    fill: "none",
    viewBox: "0 0 110 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M68.027 104.011H17.394A4.393 4.393 0 0 1 13 99.621V70.15a4.396 4.396 0 0 1 4.394-4.379h42.973a.698.698 0 1 1 0 1.395H17.394a3 3 0 0 0-2.997 2.984V99.62a2.994 2.994 0 0 0 2.997 2.995h50.633a.698.698 0 1 1 0 1.395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M60.417 100.694H22.472a.699.699 0 0 1-.698-.698V69.783a.697.697 0 0 1 .698-.698h37.945a.7.7 0 0 1 .698.698v30.213a.7.7 0 0 1-.698.698m-37.215-1.395H59.73V70.48H23.202zM18.433 90.842a.7.7 0 0 1-.699-.698v-7.03a.697.697 0 0 1 1.397 0v7.062a.697.697 0 0 1-.698.666m0-8.49a.7.7 0 0 1-.699-.698v-2.017a.697.697 0 0 1 1.397 0v2.017a.697.697 0 0 1-.698.698"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M38.028 73.773v16.534a.699.699 0 1 1-1.395 0V73.773a.699.699 0 1 1 1.395 0m0 20.187v2.879a.7.7 0 0 1-1.19.494.7.7 0 0 1-.205-.494v-2.88a.699.699 0 1 1 1.395 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M39.795 92.134a2.53 2.53 0 0 1-1.558 2.332 2.52 2.52 0 0 1-3.439-1.84 2.527 2.527 0 0 1 2.474-3.017 2.52 2.52 0 0 1 2.523 2.525m-3.65 0a1.13 1.13 0 0 0 1.312 1.166 1.126 1.126 0 0 0 .86-1.53 1.13 1.13 0 0 0-1.045-.71 1.07 1.07 0 0 0-1.094 1.074z",
    className: "scale-mobile_svg__orange-figure"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M45.434 73.8v9.669a.699.699 0 0 1-1.19.493.7.7 0 0 1-.205-.493v-9.67a.699.699 0 0 1 1.191-.493c.13.13.204.309.204.494m0 13.364v9.67a.699.699 0 0 1-1.19.493.7.7 0 0 1-.205-.494v-9.669a.699.699 0 1 1 1.395 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M47.255 85.337a2.53 2.53 0 0 1-1.557 2.333 2.52 2.52 0 0 1-3.439-1.84 2.527 2.527 0 0 1 2.474-3.017 2.52 2.52 0 0 1 2.522 2.524m-3.649 0a1.075 1.075 0 0 0 1.295.996 1.072 1.072 0 0 0 .779-1.436 1.074 1.074 0 0 0-2.074.44",
    className: "scale-mobile_svg__orange-figure"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 66,
    x: 59,
    y: 39,
    fill: "url(#scale-mobile_svg__paint0_linear_12030_11728)",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 44,
    x: 63,
    y: 48,
    fill: "#EBEBEB",
    stroke: "#2C3144",
    strokeWidth: 1.3,
    rx: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M77.856 101.448a3.224 3.224 0 0 1-3.161-3.848 3.22 3.22 0 0 1 2.532-2.53 3.225 3.225 0 0 1 3.852 3.158 3.22 3.22 0 0 1-3.223 3.22m0-4.991a1.806 1.806 0 0 0-1.782 2.148 1.8 1.8 0 0 0 1.415 1.423 1.81 1.81 0 0 0 1.856-.765 1.803 1.803 0 0 0-1.49-2.806M83.114 45.487h-2.04a.698.698 0 1 1 0-1.396h2.04a.698.698 0 1 1 0 1.396m-3.491 0h-7.026a.698.698 0 1 1 0-1.396h7.026a.699.699 0 1 1 0 1.396M89.397 57.185H72.863a.7.7 0 0 1-.494-1.19.7.7 0 0 1 .494-.205h16.534a.699.699 0 0 1 .494 1.19.7.7 0 0 1-.494.205m-20.187 0h-2.879a.699.699 0 0 1-.494-1.19.7.7 0 0 1 .494-.205h2.88a.699.699 0 0 1 .493 1.19.7.7 0 0 1-.494.205"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M71.033 58.977a2.526 2.526 0 0 1-2.477-3.014 2.52 2.52 0 0 1 1.984-1.982 2.527 2.527 0 0 1 3.017 2.474A2.52 2.52 0 0 1 72 58.785a2.5 2.5 0 0 1-.966.192m0-3.649a1.13 1.13 0 0 0-1.167 1.312 1.127 1.127 0 0 0 2.046.446c.127-.186.195-.406.195-.631a1.07 1.07 0 0 0-1.075-1.095zM89.396 64.59h-9.67a.698.698 0 1 1 0-1.395h9.67a.699.699 0 1 1 0 1.395m-13.365 0h-9.669a.698.698 0 1 1 0-1.395h9.67a.699.699 0 1 1 0 1.395"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M77.86 66.415a2.53 2.53 0 0 1-2.332-1.557 2.52 2.52 0 0 1 1.84-3.44 2.527 2.527 0 0 1 3.017 2.474 2.52 2.52 0 0 1-2.524 2.523m0-3.65a1.076 1.076 0 0 0-.995 1.295 1.072 1.072 0 0 0 1.436.78 1.074 1.074 0 0 0-.44-2.075"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 74,
    r: 10.5,
    fill: "url(#scale-mobile_svg__paint1_linear_12030_11728)",
    stroke: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M78 84.5c1.672 0 3.051-1.343 3.983-3.205.946-1.893 1.517-4.473 1.517-7.295s-.57-5.402-1.517-7.295C81.05 64.843 79.673 63.5 78 63.5c-1.672 0-3.051 1.343-3.983 3.205C73.071 68.598 72.5 71.178 72.5 74s.57 5.402 1.517 7.295C74.95 83.157 76.327 84.5 78 84.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.041 70a36.7 36.7 0 0 1-8.56-1.022.7.7 0 0 1-.406-.252.37.37 0 0 1-.04-.383.62.62 0 0 1 .36-.29 1 1 0 0 1 .543-.027c5.229 1.285 10.912 1.285 16.14 0a.97.97 0 0 1 .533.03c.165.059.291.162.351.287a.37.37 0 0 1-.031.38.67.67 0 0 1-.396.255A36 36 0 0 1 78.041 70M69.696 79.984a.9.9 0 0 1-.414-.098.57.57 0 0 1-.259-.252.38.38 0 0 1 .07-.378.72.72 0 0 1 .419-.236c5.515-1.36 11.508-1.36 17.024 0a.67.67 0 0 1 .395.257c.08.12.09.256.031.381a.6.6 0 0 1-.35.288.96.96 0 0 1-.532.03 34.2 34.2 0 0 0-16.112 0 .8.8 0 0 1-.272.008"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M78.5 63.5v21"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-mobile_svg__paint0_linear_12030_11728",
    x1: 78,
    x2: 78,
    y1: 39,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "scale-mobile_svg__orange-gradient",
    stopColor: "#464A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "scale-mobile_svg__orange-gradient",
    offset: 1,
    stopColor: "#D2D4DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scale-mobile_svg__paint1_linear_12030_11728",
    x1: 78,
    x2: 78,
    y1: 64,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0
  })))));
};
export default SvgScaleMobile;